import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import { connect } from "react-redux";

import UploadIcon from "react-icons/lib/ti/upload";
import FileIcon from "react-icons/lib/ti/document-text";
import TrashIcon from "react-icons/lib/ti/trash";
import DownloadIcon from "react-icons/lib/ti/download";
import BackIcon from "react-icons/lib/ti/arrow-back";
import ViewHeader from "../view-header";
import NotificationSystem from "react-notification-system";
import { apiActions } from "../../../_actions";
import { appConstants } from "../../../_constants";
import { appHelpers } from "../../../_helpers";
import { exchangeRateService } from "../../../_services";
import CsvFile from "../../../_assets/icons/csvFile.svg";
import { alertActions } from "../../../_actions";
const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class BulkUploadExchangeRate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedFile: null,
      notification: {
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
    };

    this.fileRef = null;
    this._notificationSystem = null;
    this._lastNotificationAdded = null;

    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.triggerFileInput = this.triggerFileInput.bind(this);
    this.uploadRate = this.uploadRate.bind(this);
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handleFileUpload(e) {
    const file = e.target.files[0];
    if (file) {
      this.setState({ uploadedFile: file });
    }
  }

  removeFile() {
    this.setState({ uploadedFile: null });
    if (this.fileRef) {
      this.fileRef.value = "";
    }
  }

  triggerFileInput() {
    if (this.fileRef) {
      this.fileRef.click();
    }
  }

  formatFileSize(bytes) {
    if (typeof bytes !== "number" || isNaN(bytes)) return "Unknown size";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }

  notify(message, level) {
    let notification = this.state.notification;
    notification.message = message;
    notification.level = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  }

  onRemove = (notification) => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  uploadRate() {
    const { uploadedFile } = this.state;
    const { dispatch } = this.props;

    if (!uploadedFile) {
      this.notify("Please upload a CSV file", appConstants.NOTIFY_ERROR);
      return;
    }

    const maxFileSize = 14 * 1024 * 1024;
    if (uploadedFile.size > maxFileSize) {
      this.notify("Maximum file size is 14 mb", appConstants.NOTIFY_ERROR);
      return;
    }

    const payload = new FormData();
    payload.append("file", uploadedFile);

    dispatch(apiActions.startRequest());

    exchangeRateService
      .uploadRate(payload)
      .then((res) => {
                    console.log(res, "res");

        const response = res.response;
        const uploadResult =
          response && response.data ? response.data : response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.notify(
            "Exchange rates uploaded successfully",
            appConstants.NOTIFY_SUCCESS,
          );
          this.removeFile();
          this.props.history.push({
            pathname: "/exchange-rate/bulk-upload/details",
            state: {
              uploadResult,
              fileName: uploadedFile.name,
            },
          });
        } else if (res.status === appConstants.ERROR_RESPONSE) {            
          const errorMessage = appHelpers.interpretApiError(res); 
          dispatch(alertActions.error(errorMessage));
        }
        dispatch(apiActions.endRequest());
      })
      .catch((err) => {
        const errorMessage = appHelpers.interpretApiError(err); 
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(alertActions.error(errorMessage));
        dispatch(apiActions.endRequest());
      });
  }

  render() {
    const { uploadedFile } = this.state;
    const { requesting } = this.props;

    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card
            className="p-4 bg-white"
            style={{ minHeight: "calc(100vh - 120px)", paddingBottom: "90px" }}
          >
            {/* Header */}

            <div
              className="d-flex align-items-center mb-5"
              onClick={() => this.props.history.push("/exchange-rate/")}
              style={{ cursor: "pointer" }}
            >
              <BackIcon size={24} className="me-2" />
              <h5 className="mb-0 fw-semibold cursor-pointer">
                Bulk Upload Exchange Rate
              </h5>
            </div>

            <Row className="justify-content-center">
              <Col lg="6">
                <div className="text-center mb-5">
                  <h1
                    className="fs-semibold mb-2 fs-5"
                    style={{ fontSize: "30px" }}
                  >
                    Add exchange rates in bulk
                  </h1>
                  <p className="text-muted fs-4">
                    Upload a CSV file containing rates data
                  </p>
                </div>

                {/* EMPTY STATE */}
                {!uploadedFile && (
                  <div>
                    <div
                      className="p-4"
                      style={{
                        border: "1px dashed #D9D9D9",
                        height: 150,
                        borderRadius: "12px",
                      }}
                    >
                      <div className="d-flex flex-column justify-content-center align-items-center">
                        <input
                          type="file"
                          accept=".csv"
                          hidden
                          ref={(input) => {
                            this.fileRef = input;
                          }}
                          onChange={this.handleFileUpload}
                        />
                        <Button
                          color="secondary"
                          onClick={this.triggerFileInput}
                        >
                          <UploadIcon size={18} className="me-2" />
                          Upload a file
                        </Button>
                        <p className="text-muted mt-3 mb-1">
                          Supported format: CSV
                        </p>
                        <p className="text-muted">Maximum file size: 14 mb</p>
                      </div>
                    </div>

                    <hr className="my-5" />

                    {/* SAMPLE TEMPLATE CARD */}
                    <div
                      className="shadow-sm"
                      style={{ background: "#FBFBFB", borderRadius: "12px" }}
                    >
                      <div className="p-4">
                        <div className="d-flex">
                          <span>
                            <img src={CsvFile} alt="CsvFile" className="mr-2" />
                          </span>

                          <div className="text-left ml-4">
                            <h3 className="fw-bold">Need a sample data?</h3>
                            <p className="text-muted mb-4">
                              Use a sample datasheet template we crafted to ease
                              uploading of exchange rate
                            </p>
                            <a href="https://avitechvideos.blob.core.windows.net/video-artifiacts/ExchangeRate-template.csv">
                              <Button color="secondary">
                                <DownloadIcon size={18} className="me-2" />
                                Download template
                              </Button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* FILE UPLOADED STATE */}
                {uploadedFile && (
                  <Card
                    className="shadow-sm border"
                    style={{ height: "120px" }}
                  >
                    <CardBody>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                          {/* <div
                            className="d-flex align-items-center justify-content-center rounded"
                            style={{
                              width: 70,
                              height: 70,
                              background: "#E9F8EE",
                            }}
                          >
                            <FileIcon size={30} color="#198754" />
                          </div> */}
                          <span>
                            <img src={CsvFile} alt="CsvFile" className="mr-2" />
                          </span>

                          <div className="ms-3 ml-4">
                            <h4 className="fw-bold mb-2">Exchange rates</h4>
                            <div className="text-muted">
                              CSV • {this.formatFileSize(uploadedFile.size)} •
                              Uploaded
                            </div>
                          </div>
                        </div>
                        <button
                          className="btn btn-light rounded-circle"
                          onClick={this.removeFile}
                        >
                          <TrashIcon size={22} />
                        </button>
                      </div>
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>

            {/* FOOTER */}
            <div
              style={{ position: "fixed", bottom: "2.8rem", right: "2.5rem" }}
            >
              {" "}
              <Button
                className="btn-avi-primary"
                disabled={!uploadedFile || requesting}
                onClick={this.uploadRate}
              >
                {requesting ? "Uploading..." : "Continue"}
              </Button>
            </div>
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { requesting } = state.api;

  return {
    requesting,
  };
}

export default connect(mapStateToProps)(BulkUploadExchangeRate);



// WEBPACK FOOTER //
// ./src/views/exchange-rate/BulkUpload/bulk-upload.js